import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "DistributeHorizontalRight"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", { d: "M22.5 1.5H21V22.5H22.5V1.5zM18 16.5H15C14.6023 16.4996 14.221 16.3414 13.9398 16.0602 13.6586 15.779 13.5004 15.3977 13.5 15V9C13.5004 8.6023 13.6586 8.22101 13.9398 7.9398 14.221 7.65859 14.6023 7.50042 15 7.5H18C18.3977 7.50042 18.779 7.65859 19.0602 7.9398 19.3414 8.22101 19.4996 8.6023 19.5 9V15C19.4996 15.3977 19.3414 15.779 19.0602 16.0602 18.779 16.3414 18.3977 16.4996 18 16.5zM15 9H14.9989L15 15H18V9H15zM10.5 1.5H9V22.5H10.5V1.5zM6 19.5H3C2.6023 19.4996 2.22101 19.3414 1.9398 19.0602 1.65859 18.779 1.50042 18.3977 1.5 18V6C1.50042 5.6023 1.65859 5.22101 1.9398 4.9398 2.22101 4.65859 2.6023 4.50042 3 4.5H6C6.3977 4.50042 6.77899 4.65859 7.0602 4.9398 7.34141 5.22101 7.49958 5.6023 7.5 6V18C7.49958 18.3977 7.34141 18.779 7.0602 19.0602 6.77899 19.3414 6.3977 19.4996 6 19.5zM3 6H2.99888L3 18H6V6H3z" }, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/DistributeHorizontalRight.vue"]]);
